// extracted by mini-css-extract-plugin
export var borderRadius = "_eo-4";
export var large = "_eo-3";
export var logoContainer = "_eo-0";
export var nameLogo = "_eo-2";
export var small = "_eo-1";